<div id="matDialogContent" class="dialog">
  <mat-dialog-content class="mat-typography" id="gesetzDialogContent">
    <p [innerHtml]="data.data"></p>
  </mat-dialog-content>
</div>
